module.exports = __webpack_public_path__ + "img/tnt_charge_logo.a7562477.png";